import type { ReactNode } from "react";
import { ErrorBoundary } from "@/core/components/ErrorBoundary";

interface Props {
  children: ReactNode;
  domainName: string;
  onError?: (error: Error, errorInfo: { componentStack: string }) => void;
  onReset?: () => void;
}

export function DomainErrorBoundary({ children, domainName, onError, onReset }: Props) {
  return (
    <ErrorBoundary
      componentName={`Domain: ${domainName}`}
      onError={onError}
      onReset={onReset}
      centered
    >
      {children}
    </ErrorBoundary>
  );
}
